import {
    GET_AAA_SERVER,
    GET_AAA_SERVER_SUCCESS,
    GET_AAA_SERVER_FAIL,
    AAA_SERVER_ADD_TRIGGER,
    AAA_SERVER_REQUEST_ADD,
    AAA_SERVER_RESPONSE_ADD_SUCCESS,
    AAA_SERVER_RESPONSE_ADD_FAIL,
    RESET_AAA_SERVER_ADD,
    AAA_SERVER_REQUEST_EDIT,
    AAA_SERVER_RESPONSE_EDIT_SUCCESS,
    AAA_SERVER_RESPONSE_EDIT_FAIL,
    RESET_AAA_SERVER_EDIT,
} from '../../constants/globalProfileConstants/aaaServerConstants';

/**
 * Reducer function for managing AAA Server list state.
 *
 * @param {object} state - Current state of the AAA Server list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const aaaServerReducer = (state = { aaaServerList: {} }, action) => {
    switch (action.type) {
        case GET_AAA_SERVER:
            return {
                ...state,
                loading: true,
            };
        case GET_AAA_SERVER_SUCCESS:
            return {
                ...state,
                loading: false,
                aaaServerList: action.payload,
            };
        case GET_AAA_SERVER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export const aaaServerTriggerReducer = (state = { aaaServerAddTrigger: false }, action) => {
    switch (action.type) {
        case AAA_SERVER_ADD_TRIGGER:
            return {
                ...state,
                aaaServerAddTrigger: action.payload,
            };
        default:
            return state;
    }
};

export const aaaServerAddReducer = (
    state = {
        statusOnAdd: null,
        addError: null,
        loading: false,
    },
    action
) => {
    switch (action.type) {
        case AAA_SERVER_REQUEST_ADD:
            return { ...state, loading: true, addError: null };
        case AAA_SERVER_RESPONSE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.payload,
            };
        case AAA_SERVER_RESPONSE_ADD_FAIL:
            return {
                ...state,
                loading: false,
                addError: action.payload,
            };
        case RESET_AAA_SERVER_ADD:
            return {
                ...state,
                loading: false,
                statusOnAdd: null,
                addError: null,
            };
        default:
            return state;
    }
};

export const aaaServerEditReducer = (
    state = {
        statusOnEdit: null,
        editError: null,
        loading: false,
    },
    action
) => {
    switch (action.type) {
        case AAA_SERVER_REQUEST_EDIT:
            return { ...state, loading: true, editError: null };
        case AAA_SERVER_RESPONSE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.payload,
            };
        case AAA_SERVER_RESPONSE_EDIT_FAIL:
            return {
                ...state,
                loading: false,
                editError: action.payload,
            };
        case RESET_AAA_SERVER_EDIT:
            return {
                ...state,
                loading: false,
                statusOnEdit: null,
                editError: null,
            };
        default:
            return state;
    }
};
